export default __webpack_public_path__ + "static/media/Flag_of_Afghanistan.826af8f8.svg";